import styles from './style.postcss';

import React, { Component } from 'react';
import CourseProgressBar from 'components/CourseProgressBar';
import PropTypes from 'prop-types';

import { PageCard, testClass } from 'omni-common-ui';

class CourseProgress extends Component {
  _getStartEvent() {
    return this.props.startEvent;
  }

  _getCurrentEvent() {
    return this.props.currentEvent;
  }

  _getEndEvent() {
    return this.props.endEvent;
  }

  _getHightLightEvent() {
    return this.props.highLightEvents;
  }

  render() {
    return <PageCard className={testClass('course-progress-view')}>
      <PageCard.Heading text="Course Progress" />
      <PageCard.Content>
        <CourseProgressBar className={styles.CourseProgress_bar}
            currentEvent={this._getCurrentEvent()}
            startEvent={this._getStartEvent()}
            endEvent={this._getEndEvent()}
            highLightEvents={this._getHightLightEvent()}>
          <div className={styles.CourseProgress_bottom}>
            <time className={styles.CourseProgress_startTime}
                dateTime={this.props.startEvent.date}>
              {this.props.startEvent.date} <br />
              (week {this.props.startWeekNumber})
            </time>
            <time className={styles.CourseProgress_endTime}
                dateTime={this.props.endEvent.date}>
              {this.props.endEvent.date} <br />
              (week {this.props.endWeekNumber})
            </time>
          </div>
        </CourseProgressBar>
      </PageCard.Content>
    </PageCard>;
  }
}

CourseProgress.propTypes = {
  currentEvent: PropTypes.object.isRequired,
  startEvent: PropTypes.object.isRequired,
  endEvent: PropTypes.object.isRequired,
  highLightEvents: PropTypes.array,
  totalSessionNumber: PropTypes.number,
  startWeekNumber: PropTypes.string,
  endWeekNumber: PropTypes.string,
};

export default CourseProgress;



// WEBPACK FOOTER //
// ./containers/Group/Dashboard/CourseProgress/index.jsx